import styled, { keyframes } from "styled-components";
import cadr_1 from './../assets/cadr_1_heart.png';
import cadr_2 from './../assets/cadr_2_heart.png';
import cadr_3 from './../assets/cadr_3_heart.png';

const frames = [cadr_1, cadr_2, cadr_3];

const animateHeart = keyframes`
  0% { background-image: url(${cadr_1}); }
  33% { background-image: url(${cadr_2}); }
  66% { background-image: url(${cadr_3}); }
  100% { background-image: url(${cadr_1}); }
`;

const Root = styled.div`
    width: 100%;
    height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  animation: ${animateHeart} 1s steps(${frames.length}) infinite;
`;

export const Heart = () => {
    return (
        <Root />
    );
}
